import State from '@/view/sidebar/store-module/interface';

const getters = {
    getSideBarVisible: (state: State) => state.sideBarVisible,
};

export default {
    getters,
};
